import { Stack, useTheme } from "@mui/material";
import { Card, IconButton, Text, VSpacer } from "@/components/DesignSystem";
import Add from "@mui/icons-material/Add";
import React from "react";
import Edit from "@mui/icons-material/Edit";
import DeleteOutline from "@mui/icons-material/DeleteOutline";

interface BrandAssetsCardGroupItemProps {
  onClick: (asset: string, mode: "add" | "edit" | "delete") => void,
  statusText?: string | null,
  title: string,
}

export const BrandAssetsCardGroupItem = ({
  statusText,
  onClick,
  title,
}: BrandAssetsCardGroupItemProps) => {
  const theme = useTheme();
  return (
    <Card
      cardContentStyle={{
        backgroundColor: theme.palette.surface2,
        height: "100%",
        padding: '12px',
        '&:last-child': {
          paddingBottom: '12px',
        },
      }}
      style={{ boxShadow: "none" }}
      testID={`${title}-card`}
    >
      <Stack alignItems="center" direction="row" justifyContent="space-between">
        <Stack sx={{ minWidth: 0 }}>
          <Text category="title-small">
            {title}
          </Text>
          {!!statusText && (
            <>
              <VSpacer size="2" />
              <Text
                category="body-medium"
                overflow="hidden"
                textOverflow="ellipsis"
                whiteSpace="nowrap"
              >
                {statusText}
              </Text>
            </>
          )}
        </Stack>
        <Stack direction="row" spacing={1.5}>
          {!statusText && (
            <IconButton
              onClick={() => onClick(title, "add")}
              size="small"
              square
              sx={{ backgroundColor: theme.palette.surface2, color: theme.palette.text.primary }}
              testID={`${title}-add-button`}
              variant="outlined"
            >
              <Add />
            </IconButton>
          )}
          {!!statusText && (
            <>
              <IconButton
                onClick={() => onClick(title, "edit")}
                size="small"
                square
                sx={{ backgroundColor: theme.palette.surface2, color: theme.palette.text.primary }}
                testID={`${title}-edit-button`}
                variant="outlined"
              >
                <Edit />
              </IconButton>
              <IconButton
                onClick={() => onClick(title, "delete")}
                size="small"
                square
                sx={{ backgroundColor: theme.palette.surface2, color: theme.palette.text.primary }}
                testID={`${title}-remove-button`}
                variant="outlined"
              >
                <DeleteOutline />
              </IconButton>
            </>
          )}
        </Stack>
      </Stack>
    </Card>
  );
};
